(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["il-product-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeReviewSliders = (root = document) => {
      root.querySelectorAll('[data-il-product-reviews]:not([data-slider-ready])').forEach((section) => {
        const viewport = section.querySelector('[data-review-viewport]');
        const slides = Array.from(section.querySelectorAll('[data-review-slide]'));
        const dots = Array.from(section.querySelectorAll('[data-review-dot]'));
        const previousButton = section.querySelector('[data-review-previous]');
        const nextButton = section.querySelector('[data-review-next]');

        section.dataset.sliderReady = 'true';
        if (!viewport || slides.length < 2) return;

        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const autoplayEnabled = section.dataset.autoplay === 'true' && !reducedMotion;
        const autoplayDelay = Number(section.dataset.autoplayDelay) || 7000;
        let activeIndex = 0;
        let autoplayTimer;
        let scrollFrame;
        let isVisible = false;
        let isPaused = false;

        const updateState = (index) => {
          activeIndex = index;
          slides.forEach((slide, slideIndex) => {
            const isActive = slideIndex === activeIndex;
            slide.classList.toggle('is-active', isActive);
            slide.setAttribute('aria-hidden', String(!isActive));
          });
          dots.forEach((dot, dotIndex) => {
            const isActive = dotIndex === activeIndex;
            dot.classList.toggle('is-active', isActive);
            if (isActive) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });
        };

        const goToSlide = (index, behavior = 'smooth') => {
          const nextIndex = (index + slides.length) % slides.length;
          viewport.scrollTo({
            left: slides[nextIndex].offsetLeft - slides[0].offsetLeft,
            behavior: reducedMotion ? 'auto' : behavior
          });
          updateState(nextIndex);
        };

        const stopAutoplay = () => {
          window.clearInterval(autoplayTimer);
          autoplayTimer = undefined;
        };

        const startAutoplay = () => {
          stopAutoplay();
          if (!autoplayEnabled || !isVisible || isPaused || document.hidden) return;
          autoplayTimer = window.setInterval(() => goToSlide(activeIndex + 1), autoplayDelay);
        };

        const restartAutoplay = () => {
          stopAutoplay();
          startAutoplay();
        };

        previousButton?.addEventListener('click', () => {
          goToSlide(activeIndex - 1);
          restartAutoplay();
        });

        nextButton?.addEventListener('click', () => {
          goToSlide(activeIndex + 1);
          restartAutoplay();
        });

        dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            goToSlide(Number(dot.dataset.reviewDot));
            restartAutoplay();
          });
        });

        viewport.addEventListener('scroll', () => {
          window.cancelAnimationFrame(scrollFrame);
          scrollFrame = window.requestAnimationFrame(() => {
            const closestIndex = slides.reduce((closest, slide, index) => {
              const closestDistance = Math.abs(slides[closest].offsetLeft - viewport.scrollLeft);
              const currentDistance = Math.abs(slide.offsetLeft - viewport.scrollLeft);
              return currentDistance < closestDistance ? index : closest;
            }, 0);
            if (closestIndex !== activeIndex) updateState(closestIndex);
          });
        }, { passive: true });

        viewport.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            goToSlide(activeIndex - 1);
            restartAutoplay();
          }
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            goToSlide(activeIndex + 1);
            restartAutoplay();
          }
        });

        section.addEventListener('pointerenter', () => {
          isPaused = true;
          stopAutoplay();
        });
        section.addEventListener('pointerleave', () => {
          isPaused = false;
          startAutoplay();
        });
        section.addEventListener('focusin', () => {
          isPaused = true;
          stopAutoplay();
        });
        section.addEventListener('focusout', () => {
          isPaused = false;
          startAutoplay();
        });

        const observer = new IntersectionObserver((entries) => {
          isVisible = entries[0].isIntersecting;
          if (isVisible) startAutoplay();
          else stopAutoplay();
        }, { threshold: 0.35 });
        observer.observe(section);

        const onVisibilityChange = () => {
          if (document.hidden) stopAutoplay();
          else startAutoplay();
        };
        document.addEventListener('visibilitychange', onVisibilityChange);

        section._ilProductReviewsCleanup = () => {
          stopAutoplay();
          observer.disconnect();
          document.removeEventListener('visibilitychange', onVisibilityChange);
          window.cancelAnimationFrame(scrollFrame);
        };
      });
    };

    initializeReviewSliders();
    document.addEventListener('shopify:section:load', (event) => initializeReviewSliders(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelector('[data-il-product-reviews]')?._ilProductReviewsCleanup?.();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["il-reviews"] && !Shopify.designMode) return;
  try {
    
  const initializeSocialProofMotion = (root = document) => {
    root.querySelectorAll('.il-social-proof:not([data-motion-ready])').forEach((section) => {
      section.dataset.motionReady = 'true';

      if (!('IntersectionObserver' in window)) {
        section.classList.add('is-in-view');
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => section.classList.toggle('is-in-view', entry.isIntersecting));
      }, { rootMargin: '160px 0px' });

      observer.observe(section);
    });
  };

  initializeSocialProofMotion();
  document.addEventListener('shopify:section:load', (event) => initializeSocialProofMotion(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["il-ticker"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('il-ticker')) {
  customElements.define('il-ticker', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const button = this.querySelector('.il-ticker__toggle');
      if (!button) return;
      button.addEventListener('click', () => {
        const paused = this.toggleAttribute('data-paused');
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
